import type { SidePanel } from '../types';

export const InvestSell: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./InvestSellPanel.vue')),
};
